import { gql, MutationFunction } from '@apollo/client';

export const UpdatePersonIdentity = gql`
  mutation UpdatePersonIdentity(
    $personIdentifier: String!
    $organizationCode: String!
    $data: IdentityUpdateInput!
  ) {
    updatePersonIdentity(
      personIdentifier: $personIdentifier
      organizationCode: $organizationCode
      data: $data
    )
  }
`;

export type UpdatePersonIdentityMutation = MutationFunction<
  {},
  UpdatePersonIdentityVariables
>;
